import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { getStep } from './../../route-component';
import AnimatedNumber from 'react-animated-number';
import OutsideNotifier from '../../OutsideNotifier';
import config from './../../config';
import common from './../../common';
import { resetTeam, autoFillTeam, triggerHandleFixturePopup } from './../../actions/FormationActions';
import trackEventsObj from './../../constants/new-pageTrackEvents';
import {
    resetAllFilters,
} from './../../actions/FilterActions';

class DesktopBudget extends Component {
    constructor(props) {
        super(props);
        this.state = {
            animationClass: false,
            elemWidth: 0,
            isMoreOpen: false,
            iVisible: false
        };
        this.timeout = null;
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.budget < 0) {
            const seenExceededBudget = common.getLocalStorage('seenExceededBudget');
            if (seenExceededBudget !== true) {
                common.setLocalStorage('seenExceededBudget', true);
                clearTimeout(this.timeout);
                setTimeout(() => {
                    this.handleBudgetTooltip();
                    clearTimeout(this.timeout);
                    this.timeout = setTimeout(() => {
                        this.handleBudgetTooltip();
                    }, 3000);
                }, 0);
            }
        }
    }

    componentWillUnmount() {
        clearTimeout(this.timeout);
        this.setState({
            isMoreOpen: false,
            iVisible: false,
        });
    }

    handleMoreIcon = () => {
        this.setState(prevState => ({
            isMoreOpen: !prevState.isMoreOpen,
        }));
    };
    handleBudgetTooltip = () => {
        this.setState(prevState => ({
            iVisible: !prevState.iVisible,
        }));
    };
    moreIconHandleOutsideClick = (e) => {
        e.stopPropagation();
        this.handleMoreIcon()
    };
    budgetTooltipHandleOutsideClick = (e) => {
        e.stopPropagation();
        this.handleBudgetTooltip()
    };
    onResetTap = () => {
        // this.props.resetAllFilters();
        const oldFormationId = this.props.defaultFormationIndex;
        this.props.resetTeam(this.props.constraints, undefined, oldFormationId);
    };
    onUpcomingFixturesTap = () => {
        this.props.triggerHandleFixturePopup(true);
    };
    onRulesTap = () => {
        common.pageViewTracking(config.RULES_URL, trackEventsObj["rules"]);
        return window.open(config.RULES_URL);
    }
    onHelpTap = () => {
        common.pageViewTracking(config.HELP_URL, trackEventsObj["help"]);
        return window.open(config.HELP_URL);
    };

    render() {
        const location = this.props.location;
        const { isMoreOpen, iVisible } = this.state;
        const { playerCount, budget, constraints } = this.props;
        const { IsFixtureUpdated } = constraints;
        const isFixtureUpdated = (IsFixtureUpdated === 1 || IsFixtureUpdated === "1");
        if (typeof budget === 'undefined') return null;
        const { MaxTeamValue } = this.props.constraints;
        const isResetEnabled = playerCount > 0;
        const isAutoCompleteDisabled = (playerCount === config.MAX_PLAYERS_PER_TEAM) || (budget < 0);
        const autoCompleteClass = common.makeClasses({
            'si-auto-fill': true,
            'si-inactive': isAutoCompleteDisabled
        });
        const IsBudgetExceeded = budget < 0;
        let msg = IsBudgetExceeded ? this.props.trans['budget_can_not_be'].replace('{VALUE}', (MaxTeamValue / config.MAX_PLAYERS_PER_TEAM).toFixed(1))
            : playerCount < config.MAX_PLAYERS_PER_TEAM
                ? this.props.trans['budget_average'].replace('{VALUE}', (budget /
                    (config.MAX_PLAYERS_PER_TEAM - playerCount)
                ).toFixed(1))
                : this.props.trans['budget_congo'];
        const menuClasses = common.makeClasses({
            'si-more-opt-mob': true,
            'si-active': isMoreOpen
        });
        const budgetWrapperClasses = common.makeClasses({
            'si-budget-wrap-common': true,
            'si-flexBox': true,
            'si-active': iVisible,
            'si-error': budget < 0
        });
        const budgetTooltipClasses = common.makeClasses({
            'si-budget-info': true,
            'si-que-mrk': true,
            'si-active': iVisible
        });
        const resetClass = common.makeClasses({
            'si-disabled': !isResetEnabled
        });
        const upcomingFixturesClass = common.makeClasses({
            'si-disabled': !isFixtureUpdated
        });
        let resetClickHandler = {};
        if (isResetEnabled) {
            resetClickHandler = { onClick: () => this.onResetTap() };
        }
        let autoCompleteHandler = {};
        if (!isAutoCompleteDisabled) {
            autoCompleteHandler = { onClick: () => this.props.autoFillTeam() };
        }
        const showRules = false;
        return <div className="si-actions-strip-sticky si-flexBox">
            <div className="si-flexBox si-section-one">
                <div className="si-plyr-count">
                    <span className="si-title">{ this.props.trans.players }</span>
                    <div className="si-val">
                        <span className="si-count-one">{ playerCount }</span><span
                            className="si-count-two">/{ config.MAX_PLAYERS_PER_TEAM }</span>
                    </div>
                </div>
                <div className={ budgetWrapperClasses }>
                    <div>
                        <span className="si-title">{ this.props.trans.budget }</span>
                        <div className="si-val"><span>€</span>
                            <AnimatedNumber value={ +budget }
                                formatValue={ (n) => (n.toFixed(1)) }
                                style={ {
                                    transition: '0.4s ease-out'
                                } }
                                duration={ 600 } /><span>m</span></div>
                    </div>
                    <div className={ budgetTooltipClasses } onClick={ () => this.handleBudgetTooltip() }>
                        <i className="icon-ucl-info" />
                        { iVisible ? <OutsideNotifier handler={ this.handleBudgetTooltip.bind(this) }>
                            <div className="si-tooltip si-budget-tooltip">
                                { IsBudgetExceeded &&
                                    <span className="si-title">{ this.props.trans['budget_exceeded'] }</span> }
                                <span
                                    className="si-text">{ msg }</span>
                            </div>
                        </OutsideNotifier> : null }
                    </div>
                </div>
                {/* <div className="si-budget-lightbox"/> */ }
                {/* <div className="si-inner-wrap-web si-flexBox">
                    <div className="si-total-cost"><span>€</span><span>
                        <AnimatedNumber value={+budget}
                            formatValue={(n) => (n.toFixed(1))}
                            style={{
                                transition: '0.4s ease-out'
                            }}
                            duration={600} /></span><span>m</span></div>
                    <span className="si-currency-anm">€</span>
                    <span className="si-currency-anm">€</span>
                    <span className="si-currency-anm">€</span>
                    <span className="si-currency-anm">€</span>
                    <span className="si-currency-anm">€</span>
                    <span className="si-currency-anm">€</span>
                    <span className="si-currency-anm">€</span>
                    <span className="si-currency-anm">€</span>
                    <span className="si-currency-anm">€</span>
                    <span className="si-currency-anm">€</span>
                    <span className="si-currency-anm">€</span>
                    <span className="si-currency-anm">€</span>
                    <span className="si-currency-anm">€</span>
                    <span className="si-currency-anm">€</span>
                    <span className="si-currency-anm">€</span>
                    <span className="si-currency-anm">€</span>
                    <span className="si-currency-anm">€</span>
                    <span className="si-currency-anm">€</span>
                    <span className="si-currency-anm">€</span>
                    <span className="si-currency-anm">€</span>
                </div> */}
            </div>
            <div className="si-flexBox si-section-two">
                <div className={ autoCompleteClass } { ...autoCompleteHandler }>
                    <i className="icon-ucl-Auto-Complete" />
                    <span>{ this.props.trans['auto'] } <br />{ this.props.trans.complete }</span>
                </div>
                <div className={ menuClasses } onClick={ () => this.handleMoreIcon() }>
                    <i className="icon-ucl-more" />
                    { isMoreOpen ? <OutsideNotifier handler={ this.handleMoreIcon.bind(this) }>
                        <div className="si-more-menu">
                            { getStep(location.pathname) === 0 ?
                                <span
                                    className={ resetClass } { ...resetClickHandler }>{ this.props.trans.reset }</span> : null }
                            { (getStep(location.pathname) === 0 && isFixtureUpdated) && common.isMobile() ?
                                <span className={ upcomingFixturesClass }
                                    onClick={ () => this.onUpcomingFixturesTap() }>{ this.props.trans.upcomingFixtures }</span> : null }
                            { showRules ?
                                <span onClick={ () => this.onRulesTap() }>{ this.props.trans['menu_rules'] }</span> : null }
                            {/* <span onClick={ () => this.onHelpTap() }>{ this.props.trans['help_n_feedback'] }</span> */}
                        </div>
                    </OutsideNotifier> : null }

                </div>
            </div>
        </div>
    }
}

const mapStateToProps = (state) => {
    return {
        trans: state.appData.trans,
        constraints: state.appData.constraints,
        budget: state.formationData.teamData.budget,
        playerCount: state.formationData.teamData.playerCount,
        defaultFormationIndex: state.formationData.defaultFormationIndex,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        resetAllFilters: () => dispatch(resetAllFilters()),
        resetTeam: (constraints, oldFormationId, newFormationId) => dispatch(resetTeam(constraints, oldFormationId, newFormationId)),
        autoFillTeam: () => dispatch(autoFillTeam()),
        triggerHandleFixturePopup: (isFixturePopupVisible) => dispatch(triggerHandleFixturePopup(isFixturePopupVisible))
    };
};
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DesktopBudget));


// WEBPACK FOOTER //
// ./src/components/onboarding/DesktopBudget.js